import Layout from "@/components/Layout";
import { Mail, Phone, MapPin, Clock, AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import SEOHead from "@/components/SEOHead";
import { LocalBusinessJsonLd } from "@/components/JsonLd";

const Kontakt = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEOHead
        title="Kontakt – producent naklejek 3D wypukłych (doming)"
        description="Skontaktuj się z producentem naklejek 3D zalewanych żywicą: telefon, e-mail i formularz. Odpowiadamy na zapytania B2B i przygotujemy wycenę naklejek."
      />
      <LocalBusinessJsonLd />
      <section className="gradient-navy py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-primary-foreground mb-4">
            <span className="text-gradient-gold">{t("contactPage.title")}</span>
          </h1>
          <p className="text-primary-foreground/80 text-lg">{t("contactPage.subtitle")}</p>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <div className="space-y-8">
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl gradient-gold flex items-center justify-center shrink-0">
                    <Mail className="w-5 h-5 text-accent-foreground" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">{t("contactPage.email")}</p>
                    <a href="mailto:biuro@projekt-art.pl" className="text-muted-foreground hover:text-accent transition-colors">biuro@projekt-art.pl</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl gradient-gold flex items-center justify-center shrink-0">
                    <Phone className="w-5 h-5 text-accent-foreground" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">{t("contactPage.phone")}</p>
                    <a href="tel:+48534900620" className="text-muted-foreground hover:text-accent transition-colors">+48 534 900 620</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl gradient-gold flex items-center justify-center shrink-0">
                    <MapPin className="w-5 h-5 text-accent-foreground" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">{t("contactPage.address")}</p>
                    <p className="text-muted-foreground">ul. Głogowa 39, 40-750 Katowice</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl gradient-gold flex items-center justify-center shrink-0">
                    <Clock className="w-5 h-5 text-accent-foreground" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">{t("contactPage.workingHours")}</p>
                    <p className="text-muted-foreground">{t("contactPage.workingHoursValue")}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 bg-accent/10 border border-accent/20 rounded-xl p-4">
                  <AlertCircle className="w-5 h-5 text-accent mt-0.5 shrink-0" />
                  <div>
                    <p className="font-semibold text-foreground text-sm">{t("contactPage.visitOnly")}</p>
                    <p className="text-muted-foreground text-sm">{t("contactPage.visitOnlyDesc")}</p>
                  </div>
                </div>

                <div className="bg-muted/50 border border-border rounded-xl p-5">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {t("contactPage.owner")} <span className="font-semibold text-foreground">DRUKEXPERT.PL Sp. z o.o.</span> (NIP: 954 287 50 30).
                  </p>
                </div>
              </div>

              <div className="rounded-xl overflow-hidden border border-border h-64">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2564.1!2d19.0247!3d50.2354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4716ce4b5c7a7e1d%3A0x1!2sul.+G%C5%82ogowa+39%2C+40-750+Katowice!5e0!3m2!1spl!2spl!4v1"
                  width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy"
                  title="Lokalizacja – ul. Głogowa 39, Katowice"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Kontakt;
